<template>
	<div style="background-color: #EFEFEF;height: 800px">
		<div style="height: 8%;width: 100%;" class="middle-row center">
			<h2>事件中心</h2>
		</div>
		<div style="height: 90%;width: 100%;" class="middle-row around">
			<div style="width: 48%;height: 100%;background-color: white;overflow-y: scroll;padding: 20px;">
				<h3 style="color: red;font-weight: bolder;">未处理事件列表</h3>
				<table class="table table-condensed  table-hover" style="width: 100%;margin-top: 10px;">
					<thead>
						<tr>
							<th v-for="(item,i) in tablelist" :key="i">{{item}}</th>
						</tr>
					</thead>
					<tbody>
							<tr v-for="(eve,index) in events" :key="index" v-if="!eve.state">
								<td>
									<div>{{eve.eventName}}-{{eve.count}}</div>
									<div>{{timelist[index]}}</div>
								</td>
								<td>{{eve.merchantName}}</td>
								<td>
									<div v-for="i in eve.count" :key="i">{{Object.keys(eve.values[i-1])[0]}}</div>
								</td>
								<td>
									<div style="color: red;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.values[i-1])[0]}}</div>
								</td>
								<td>
									<div style="color: green;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.standards[i-1])[0]}}</div>
								</td>
								<td><button class="btn btn-sm btn-warning" @click="todo(index)" data-target="#eventModal" data-toggle="modal">处理</button></td>
							</tr>
					</tbody>
				</table>
			</div>
			<div style="width: 48%;height: 100%;background-color: white;overflow-y: scroll;padding:20px;">
				<h3 style="color: green;font-weight: bolder;">已处理事件列表</h3>
				<table class="table table-condensed" style="width: 100%;margin-top: 10px;">
					<thead>
						<tr>
							<th v-for="(item,i) in tablelist" :key="i">{{item}}</th>
						</tr>
					</thead>
					<tbody>
							<tr v-for="(eve,index) in events" :key="index" v-if="eve.state">
								<td style="color: green;font-weight:bold">
									<div>{{eve.eventName}}-{{eve.count}}</div>
									<div>{{timelist[index]}}</div>
								</td>
								<td>{{eve.merchantName}}</td>
								<td>
									<div v-for="i in eve.count" :key="i">{{Object.keys(eve.values[i-1])[0]}}</div>
								</td>
								<td>
									<div style="color: grey;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.values[i-1])[0]}}</div>
								</td>
								<td>
									<div v-for="i in eve.count" :key="i">{{Object.values(eve.standards[i-1])[0]}}</div>
								</td>
								<td><button class="btn btn-sm btn-success" @click="todetail(index)" data-target="#detailModal" data-toggle="modal">查看详情</button></td>
							</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="modal fade" id="eventModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
		    <div class="modal-dialog" style="height:80%;width:100%;margin: 0px;">
		        <div class="modal-content clearfix"  style="height:100%;width:100%;">
		            <div class="modal-header">
		                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
		                <h4 class="modal-title" id="myModalLabel">事件处理中心</h4>
		            </div>
		            <div class="modal-body" style="position: absolute;top: 56px;bottom: 65px;width: 100%;">
						<table class="table" style="font-size: 15px;font-weight: bold;">
							<thead>
								<tr>
									<th v-for="(item,index) in tablelist2" :key="index">{{item}}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="eve.state==false" @click="chooseMer">
									<td>{{eve.eventName}}</td>
									<td>{{eve.merchantName}}</td>
									<td>{{timelist[index]}}</td>
									<td>
										<div v-for="i in eve.count" :key="i">{{Object.keys(eve.values[i-1])[0]}}</div>
									</td>
									<td>
										<div style="color: red;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.values[i-1])[0]}}</div>
									</td>
									<td>
										<div style="color: green;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.standards[i-1])[0]}}</div>
									</td>
								</tr>
							</tbody>
						</table>
						<hr/>
						<div style="width: 100%;" class="middle-row around">
							<div class="input-group" style="width:48%;;">
								<span class="input-group-addon">事件处理过程</span>
								<textarea style="font-size: 20px;" v-model="detail" cols="20" rows="10"  class="form-control" id="process" /></textarea>
							</div>
							<div style="width:48%">
								<baidu-map class="bm-view" :zoom="14" :center="{lng:merchant.longitude,lat:merchant.latitude}"  ak="OydBLLOIYzqXFEIoDNyBKM5lVuNYhucB"
								 :scroll-wheel-zoom='true' style="height: 400px;">
									<bm-marker :title="merchant.merchantName" :position="{lng:merchant.longitude,lat:merchant.latitude}" :dragging="false" animation="BMAP_ANIMATION_BOUNCE">
									</bm-marker>
									<bm-marker :title="merchant.merchantName" :position="{lng:merchant.longitude,lat:merchant.latitude}" :icon="{url:'https://www.mwhs.cn/api/warning.png',size: {width:36, height:46}}">
									</bm-marker>
								</baidu-map>
							</div>
						</div>
					</div>
		            <div class="modal-footer" style="position: absolute;bottom: 0px;width: 100%;">
		                <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
		                <button type="button" class="btn btn-primary" @click="submitDetail">提交处理</button>
		            </div>
		        </div><!-- /.modal-content -->
		    </div><!-- /.modal -->
		</div>
		<div class="modal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
		    <div class="modal-dialog" style="height: 100%;width: 100%;margin: 0px;">
		        <div class="modal-content"  style="height:60%;width: 100%;">
		            <div class="modal-header">
		                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
		                <h4 class="modal-title" id="myModalLabel">事件处理记录</h4>
		            </div>
		            <div class="modal-body" style="position: absolute;top: 56px;bottom: 65px;width: 100%;">
						<table class="table" style="font-size: 15px;font-weight: bold;">
							<thead>
								<tr>
									<th v-for="(item,index) in tablelist3" :key="index">{{item}}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="eve.state==true">
									<td>{{eve.eventName}}</td>
									<td>{{timelist[index]}}</td>
									<td>{{processtimelist[index]}}</td>
									<td>{{eve.merchantName}}</td>
									<td>
										<div v-for="i in eve.count" :key="i">{{Object.keys(eve.values[i-1])[0]}}</div>
									</td>
									<td>
										<div style="color: darkgrey;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.values[i-1])[0]}}</div>
									</td>
									<td>
										<div style="color: green;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.standards[i-1])[0]}}</div>
									</td>
								</tr>
							</tbody>
						</table>
						<hr/>
						<div style="widows: 100%;">
							<div class="input-group">
								<span class="input-group-addon">事件处理过程</span>
								<textarea style="font-size: 20px;" v-model="eve.detail" cols="20" rows="5" class="form-control" id="process"/></textarea>
							</div>
						</div>
					</div>
		            <div class="modal-footer" style="position: absolute;bottom: 0px;width: 100%;">
		                <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
		                <button type="button" class="btn btn-primary" @click="submitDetail">提交处理</button>
		            </div>
		        </div><!-- /.modal-content -->
		    </div><!-- /.modal -->
		</div>
		<div class="modal fade" id="loadingModal">
		    <div style="width: 200px;height:20px; z-index: 20000; position: absolute; text-align: center; left: 50%; top: 50%;margin-left:-100px;margin-top:-10px">
		        <div class="progress progress-striped active" style="margin-bottom: 0;">
		            <div class="progress-bar" style="width: 100%;"></div>
		        </div>
		        <h5>正在加载...</h5>
		    </div>
		</div>
	</div>
</template>

<script>
	import {util} from '../../static/util.js'
	import {BaiduMap,BmMarker,BmCircle,BmBoundary} from 'vue-baidu-map'
	export default ({
		data() {
			return {
				events: [],
				tablelist: ['事件类型', '所属企业', '超标内容', '超标值', '标准值','处理'],
				tablelist2: ['事件类型','所属企业', '发生时间','超标内容', '超标值', '标准值'],
				tablelist3: ['事件类型','发生时间','处理时间','所属企业', '超标内容', '超标值', '标准值'],
				eve:{},
				timelist:[],
				index:0,
				processtimelist:[],
				detail:'',
				merchant:'',
			}
		},
		methods: {
			chooseMer:function () {
				this.$http.get(this.GLOBAL.base+'getMerchantByEquId',{params:{equId:this.eve.equId}}).then(function(msg) {
					this.merchant = msg.body;
				})
			},
			todo:function (index) {
				var that = this;
				this.eve = this.events[index];
				this.index = index;
				this.$http.get(this.GLOBAL.base+'getMerchantByEquId',{params:{equId:this.eve.equId}}).then(function(msg) {
					setTimeout(function() {
						that.merchant = msg.body;
					}, 300);
					
				})
			},
			todetail:function (index) {
				this.eve = this.events[index];
				this.index = index;
			},
			submitDetail:function() {
				if(this.detail==''){
					alert("请输入处理过程！");
					return;
				}
				this.eve.detail = this.detail;
				this.$http.post(this.GLOBAL.base+'updateEvent',this.eve,{emulateJSON:true}).then(function(msg) {
					alert("提交成功");
					this.$parent.$data.untreated--;
					this.eve = msg.body;
					$("#eventModal").modal("hide");
					$("#detailModal").modal("hide");
					this.detail=''
					this.getAllEvent();
				})
			},
			getAllEvent:function() {
				$("#loadingModal").modal('show');
				this.$http.get(this.GLOBAL.base + "getAllEvent").then(function(msg) {
					this.timelist=[];
					this.processtimelist=[];
					this.events = msg.body
					for(let eve of this.events) {
						this.timelist.push(util.timeToStringWithMonth(eve.time));
						this.processtimelist.push(util.timeToStringWithMonth(eve.processedTime));
					}
					this.eve=this.events[0];
					$("#loadingModal").modal('hide');
				})
			},
		},
		mounted() {
			this.getAllEvent();
		},
		components: {
			BaiduMap,
			BmMarker,
			BmCircle,BmBoundary
		},
	})
</script>

<style>
	.table tbody tr td{
		vertical-align: middle;
		font-family: '微软雅黑' !important;
	}
	
	.bm-view{
		width: 100%;
	}
	
</style>
